import React from 'react';
import { useLocation } from 'react-router';

import { DUMMY_GAME_DETAILS, GetGameDetailsFromCurrentURL } from 'context/url_based_context';

// mockGameName is used when only chain details are needed, but not the game contracts
function useGameDetails(mockGameName) {
  let gameDetails = DUMMY_GAME_DETAILS; // this line also adds type hints for IDEs
  const location = useLocation();
  gameDetails = React.useMemo(() => GetGameDetailsFromCurrentURL(mockGameName)
    , [location.pathname, mockGameName]); // eslint-disable-line react-hooks/exhaustive-deps

  return gameDetails;
};

export default useGameDetails;
